import TreeSelect from './tree-select';

export default TreeSelect;
